import type { DeityId, Wallpaper } from '../data/types'
import './WallpaperCard.css'

const DEITY_LABEL: Record<DeityId, string> = {
  vinayagar: 'விநாயகர்',
  murugan: 'முருகன்',
  shiva: 'சிவன்',
  amman: 'அம்மன்',
  lakshmi: 'லக்ஷ்மி',
  vishnu: 'விஷ்ணு',
  hanuman: 'அனுமன்',
  ayyappan: 'ஐயப்பன்',
  other: 'ஆன்மீகம்',
}

export function WallpaperCard({ item }: { item: Wallpaper }) {
  async function download() {
    try {
      const res = await fetch(item.imageUrl)
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${item.id}-deiveega-oosai.jpg`
      a.click()
      URL.revokeObjectURL(url)

      const w = window as Window & { gtag?: (...args: unknown[]) => void }
      w.gtag?.('event', 'wallpaper_download', { event_label: item.id })
    } catch {
      window.open(item.imageUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <article className="wallpaper-card">
      <figure className="wallpaper-card__preview">
        <img
          src={item.imageUrl}
          alt={`${item.titleTa} — ${item.titleEn} mobile wallpaper`}
          width={360}
          height={640}
          loading="lazy"
          decoding="async"
        />
      </figure>
      <div className="wallpaper-card__body">
        <h3>{item.titleTa}</h3>
        <p>
          {item.titleEn} · {DEITY_LABEL[item.deity]} · 9:16
        </p>
        <button type="button" className="btn btn--outline" onClick={download}>
          பதிவிறக்கு
        </button>
      </div>
    </article>
  )
}
